<template>
  <WorkerColumn
    :worker-id="column.worker.id"
    :name="column.worker.name"
    :email="column.worker.email"
    show-email
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import WorkerColumn from '@/components/GraphqlDataTable/columns/WorkerColumn.vue'

const PaymentRequestWorkerColumn = graphql(`
  fragment PaymentRequestWorkerColumn on PaymentRequest {
    id
    worker {
      id
      name
      email
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestWorkerColumn>
}>()

const column = computed(() => useFragment(PaymentRequestWorkerColumn, props.row))
</script>

<style scoped></style>
